import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=545d3db0&scoped=true&"
import script from "./DocumentsSection.vue?vue&type=script&lang=js&"
export * from "./DocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSection.vue?vue&type=style&index=0&id=545d3db0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d3db0",
  null
  
)

export default component.exports